module.exports = require("@mui/icons-material/SkipNext");